const enTranslations = {
/*********************
  Captions and Screens name
*********************/
  home : 'Home',
  management: 'Management',
  account: 'Account',
  servicemenu:"Service Menu",
  asoko2: 'à sôko 2【IdeaSim】',
  asoko2cmt:"Simulator for optimizing operations at warehouse",
  asokoplus:'à sôko +　　　　　　　　　　',
  asokopluscmt:"3D layout simulator for warehouse",
  newexec: 'NEW - EXECUTION',
  reshis:'RESULT - HISTORY',
  picking_newexec: 'Model F Optimized Simuation NEW - EXECUTION',
  picking_reshis:  'Model F Optimized Simuation RESULT - HISTORY',
  picking_general_newexec: 'Model G Optimized PickingList NEW - EXECUTION',
  picking_general_reshis:  'Model G Optimized PickingList RESULT - HISTORY',
 // simulation_newexec: 'Optimization scenario verification NEW - EXECUTION',
 // simulation_reshis:'Optimization scenario verification RESULT - HISTORY',
  title_create_account: 'CREATE AN ACCOUNT',
  title_create_company: 'CREATE A CORPORATION',
  title_api_key_issued: 'API Key Issued',
  title_create_warehouse: 'CREATE A BRANCH',
  title_edit_account: 'EDIT AN ACCOUNT',
  title_edit_company: 'EDIT A CORPORATION',
  title_edit_warehouse: 'EDIT A BRANCH',
  opt_scenario_verif: 'Execute Scenarios for Optimization',
  opt_picking_list: 'Picking List',
  opt_picking_list_full: 'Model F Optimized Simulation', //'Create Optimized Picking List(Full Model)',
  opt_picking_list_general: 'Model G Optimized Picking List', // 'Create Optimized Picking List(General Model)',

/*********************
  Buttons
*********************/
  create_user: 'Add New Account',
  create_company: 'Add New Company',
  create_warehouse: 'Add New Branch',
  upload: 'Upload',
  execute: 'Execute',
  register: 'Register',
  edit: 'Edit',
  delete: 'Delete',
  cancel: 'Cancel',
  back:'◀Back',
  asoko2exec:"RUN▶",

  /*********************
  Input fields "Labels"
*********************/
  email: 'Email',
  confirm_email: 'Confirm Email',
  password: 'Password',
  confirm_password: 'Confirm Password',
  account_name: 'Account Name',
  company_name: 'Corporate Name',
  company_short_name: 'Corporate Code',
  warehouse_name: 'Branch Name',
  warehouse_short_name: 'Branch Code',
  full_name: 'Full Name',
  last_name: 'Last Name',
  first_name: 'First Name',
  role: 'Permission',
  select_file_for_upload: '▶ Select a File for Upload',
  message_upload_done: 'Upload completed',
  is_notification: 'Receive an email when simulation completes',
  export_result_file: 'Export a report of simulation results',
  export_excel: 'Export a picking list file in EXCEL format (in addition to CSV)',

/*********************
  List items "Labels"
*********************/
  simulation_model_files: 'Simulation Model Files',
　location_files: 'Location File',
  master_files: 'Data Files',
  updated_user: 'User', //'Updatede by',
  executed_user: 'Executed by',
  master_kind: 'Master kind',
  model_kind: 'Model kind',
  exec_filename: 'File Name',
  executed: 'Time of Execution',
  updated: 'Time of Update',
  result: 'Result',
  model_filename: 'File Name',
  master_filename: 'File Name',
  workload_list: 'Report of Workload',
  execution_log: 'Log File',
  limit_simulation_sec: 'Limit of Simulation Exec Sec',
  limit_simulation_sec_short: 'Limit of Simulation Exec Sec',
  
/*********************
  Master Classification
*********************/
  select_kind_of_master: 'Select the Files',
  parameter_master: 'Variable Settings',
  merchandise_master: 'Product Master',
  packing_master: 'Packing Master',
  delivery_master: 'Transportation Master',
  inventory_data: 'Inventory Data',
  shipment_data: 'Shipping Data',
  condition_data: 'Condition Setting',

/*********************
  Authorities
*********************/
  role_admin: 'Admin',
  role_manager: 'Manager',
  role_user: 'User',
  role_viewer: 'Viewer',

/*********************
  Model,Master kind
*********************/
  file_simulation_model: 'Model_Simulation',
  file_picking_model: 'Model F(full model)', //'Model_Picking List',
  file_general_model: 'Model G(general model)',
  file_condition: 'Condition Settings File', //'00_Variable Settings File',
  file_shipment: 'Shipping File', //'05_Shipping File',
  file_location: 'Location File', //'06_Location File',


/*********************
  Messages
*********************/
  exec_message: 'Do you want to run the simulation model?',
  delete_message: 'Are you sure you want to delete the file/record?',
  login_error: 'Login failed. Please check your email address or password.',
  email_does_not_match: 'The email address you entered does not match the registered email address.',
  password_does_not_match: 'The password you entered does not match the registered password.',
  assigned_warehouses_empty: 'Please select your Branch Name.',
  upload_all_files: 'Please upload all types of files.',
  exec_in_progress: 'Simulation Running.',
  exec_is_done: 'Simulation Completed.',
  exec_has_error: 'Simulation Error.',
  company_short_name_validation_error: 'Please use only capital letters or numbers for "Corporate Name (abbreviation)".',
  warehouse_short_name_validation_error: 'Please use only capital letters and numbers in "Branch Name (abbreviation)".',
  warehouse_limit_simulation_sec_error: 'Please use only integer value in "Limit of Simulation Exec Sec"',
  email_invalid_format: 'The email address format is invalid.',
  email_duplicated: 'Entered email address is already registered.',
  company_code_duplicated: 'Entered Corporate Code is already registered.',
  company_name_duplicated: 'Entered Corporate Name is already registered.',
  warehouse_duplicated: 'Entered Branch Code are already registered.',
  file_size_error: 'The maximum file size you can upload is 50MB.',
  session_timeout: 'Your session has timed out. Please log in again.',

/*********************
  Plant Simulation Erroe Message
*********************/

// YASUDA Model 
  N_001_00_01: 'Completed.',

  E_001_00_01: 'Loading the Variable Settings File failed.',
  E_001_00_02: 'The row and column definition in the Variable Settings File is invalid.',
  E_001_00_03: 'The Variable Settings File contains invalid values.',

  E_001_02_01: 'Loading The Shipping (Picking) File failed.',
  E_001_02_02: 'The column definition for the Shipping (Picking) File is invalid.',
  E_001_02_03: 'The Shipping (Picking) File contains invalid values.',

// 汎用モデル
  N_000_00_01: 'Completed',
  W_000_03_01: 'The simulation has completed, but the outbound data contains invalid locations.',
  E_000_01_01: 'Failed to load wall/column files.',
  E_000_01_02: 'Invalid row and column definitions in the "Dimensions" sheet.',
  E_000_01_03: 'Invalid values ??are contained in the "Dimensions" sheet.',
  E_000_01_04: 'Invalid row definitions in the "Column X-direction spacing" sheet.',
  E_000_01_05: 'Invalid values ??are contained in the "Column X-direction spacing" sheet.',
  E_000_01_06: 'Invalid column definitions in the "Column Y-direction spacing" sheet.',
  E_000_01_07: 'Invalid values ??are contained in the "Column Y-direction spacing" sheet.',
  E_000_01_08: 'Invalid column definitions in the "Column" sheet.',
  E_000_01_09: 'Invalid values ??are contained in the "Column" sheet.',
  E_000_01_10: 'Invalid column definitions in the "Wall" sheet.',
  E_000_01_11: 'Invalid values ??are contained in the "Wall" sheet.',
  E_000_01_12: 'Invalid column definitions in the "Shutter" sheet.',
  E_000_01_13: 'Invalid values ??are contained in the "Shutter" sheet.',
  E_000_02_01: 'Failed to load location files.',
  E_000_02_02: 'Invalid column definitions in the "Rack Size" sheet.',
  E_000_02_03: 'Invalid values ??are contained in the "Rack Size" sheet.',
  E_000_02_04: 'The row definition in the "Rack Layout" sheet is invalid.',
  E_000_02_05: 'The "Rack Layout" sheet contains invalid values.',
  E_000_02_06: 'The row and column definitions in the "Work Location" sheet are invalid.',
  E_000_02_07: 'The "Work Location" sheet contains invalid values.',
  E_000_03_01: 'Failed to load the condition settings file.',
  E_000_03_02: 'The row and column definitions in the "Condition Settings" sheet are invalid.',
  E_000_03_03: 'The row and column definitions in the "Worker Settings" sheet are invalid.',
  E_000_03_04: 'The row and column definitions in the "Outbound Data Settings" sheet are invalid.',
  E_000_03_05: 'The row and column definitions in the "Area/Location Settings" sheet are invalid.',
  E_000_03_06: 'The "Condition Settings" sheet contains invalid values.',
  E_000_03_07: 'The "Worker Settings" sheet contains invalid values.',
  E_000_03_08: 'The "Outbound Data Settings" sheet contains invalid values.',
  E_000_03_09: 'The "Area/Location Settings" sheet contains invalid values.',
  E_000_03_10: 'The row and column definitions in the "Transportation Method Settings" sheet are invalid.',
  E_000_03_11: 'The "Transportation Method Settings" sheet contains invalid values.',
  E_000_03_13: 'The "Picking Method Settings" sheet contains invalid values.',
  E_000_04_01: 'Failed to load outbound data.',
  E_000_04_02: 'The column definition is invalid.',
  E_000_04_03: 'It contains invalid values.',
  E_000_99_01: 'An unexpected error occurred.',

  //共通
  E_999_00_01: 'System error occurred. Please contact your administrator at support@a-soko.jp',
  E_999_00_02: 'Simulation was timed out. Please contact your administrator at support@a-soko.jp.',


  // Login and register screens
  createAccount: 'Create an account',
  alreadyAccount: 'Have an account?',
  login: 'Login',
  loginAccount: 'Login to your account',

  lang:'Language',


  "pallet_rack_2p_1s": "2 Pallets / 1 Side",
  "pallet_rack_1p_1s": "1 Pallet / 1 Side",
  "pallet_rack_2p_2s": "2 Pallets / 2 Sides",
  "pallet_rack_1p_2s": "1 Pallet / 2 Sides",
  "nesting_rack_1p_1s": "1 Pallet / 1 Side",
  "nesting_rack_2p_2s": "2 Pallets / 2 Sides",
  "mdr_1w_1s": "0.9m / 1 Side",
  "mdr_2w_1s": "1.8m / 1 Side",
  "mdr_2w_2s": "0.9m / 2 Sides",
  "mdr_1w_2s": "1.8m / 2 Sides",
  "fc_1c_1s": "1 Case / 1 Side",
  "fc_1c_2s": "1 Case / 2 Sides",
  "carton_boxes": "",

  psch: "Pillar Span + Ceiling Height",
  efch: "Effect ceil height",
  mrpu: "Monthly rent per unit",
  unitPrice: "JPY/Tsubo",
};

export default enTranslations;
